import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import Input from '../input';
import DropdownComp from '../dropdown';

import { getProductsList } from '../../helpers/listsApi';
const DynamicAddMerchantRow = (props) => {
    const token = useSelector((state) => state.auth.token);
   // eslint-disable-next-line
    const { index, values, handleChange, setFieldValue, isSubmitting,
         brands, products, touched, errors, handleRemoveMerchant, setFirstmargin } = props

    const [ test, setTest ] = useState([])
   // eslint-disable-next-line
    const [ trueTest, setTrueTest ] = useState(false)

    //  console.log(products, ' mmmm')    
    useEffect(() => {
        if(errors){
            // console.log(errors.brandAccess, ' qwe')
            // console.log(errors.brandAccess[index].margin, ' qwe')
        }
    }, [errors])
    
    useEffect(() => {
        if(products && products.length){
            setTest(products[0])
            }else{
                setTest([])
            }
        }, [ products ])
        
    useEffect(() => {
    setFirstmargin(test.margin)
    // eslint-disable-next-line         
    }, [ test ])

    return (
        <div className="form-row">
            <div className="form-group col-md-4">
                <DropdownComp
                    id={`brandAccess[${index}].brandId`}
                    name={`brandAccess[${index}].brandId`}
                    onChange={async (selectedValue) => {
                        setFieldValue(`brandAccess[${index}].brandId`, selectedValue)
                      const data = await getProductsList(selectedValue.value,token)
                        setFieldValue(`brandAccess[${index}].productId`, [])
                        setFieldValue(`brandAccess[${index}].products`, data)
                    }}
                    value={values.brandAccess[index].brandId}
                    options={brands}
                    label="Brand"
                    placeholder="Please select"
                    error={touched.brandAccess &&errors.brandAccess&& errors.brandAccess[index] && errors.brandAccess[index].brandId}
                    errorText={errors.brandAccess && errors.brandAccess[index] && errors.brandAccess[index].brandId}
                    disabled={isSubmitting} />
            </div>
            <div className="form-group col-md-4">
                <DropdownComp
                    isMulti
                    id={`brandAccess[${index}].productId`}
                    name={`brandAccess[${index}].productId`}
                    onChange={(selectedValue) => {
                        setFieldValue(`brandAccess[${index}].productId`, selectedValue)
                    }}
                    value={values.brandAccess[index].productId}
                    options={products}
                    label="Product Name"
                    placeholder="Please select"
                    error={touched.brandAccess &&errors.brandAccess&& errors.brandAccess[index] && errors.brandAccess[index].productId}
                    errorText={errors.brandAccess && errors.brandAccess[index] && errors.brandAccess[index].productId}
                    disabled={isSubmitting} />
            </div>
            <div className="form-group col-md-4">
            <Input
            id={`brandAccess[${index}].margin`}
            name={`brandAccess[${index}].margin`}
            placeholder="Enter margin"
            type="number"
            label="Margin Offered"
            value={values.brandAccess[index]?.margin}  // ✅ Corrected
            minimum={true}
            maximum={test?.margin || ""}
            hasStep={true}
            onChange={event => setFieldValue(`brandAccess[${index}].margin`, event.target.value)} // ✅ Corrected
            error={touched.brandAccess && errors.brandAccess && errors.brandAccess[index]?.margin}
            errorText={
                errors.brandAccess && errors.brandAccess[index]?.margin + 
                (test?.margin ? ` (smaller or equal to ${test.margin})` : "")
            }
            disabled={isSubmitting}
        />
                  {values.brandAccess && values.brandAccess.length > 1 &&
                    <button type="button" class="" aria-label="Close"
                        id={`brandAccess[${index}].deleteProduct`}
                        name={`brandAccess[${index}].deleteProduct`}
                        style={{ position: 'absolute', top: '0', right: '0', border: 'none', background: 'transparent', display: 'flex' }}
                        onClick={handleRemoveMerchant}
                    >
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.146-3.146a.5.5 0 0 0-.708-.708L8 7.293 4.854 4.146a.5.5 0 1 0-.708.708L7.293 8l-3.147 3.146a.5.5 0 0 0 .708.708L8 8.707l3.146 3.147a.5.5 0 0 0 .708-.708L8.707 8l3.147-3.146z" />
                        </svg>
                    </button>}
            </div>
        </div>
    )
}
export default DynamicAddMerchantRow;